/* eslint-disable */
import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import CountryCode from '../../../../data/countrycode.json';
import { useNavigate } from 'react-router-dom';
import { updateProfile } from '../../../../services/operations/profileApi';
import { useDispatch } from 'react-redux';

const UpdateUserDetails = ({ user }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const {
        register,
        handleSubmit,
        setValue,
        formState: { errors }
    } = useForm();

    const updateDetailHandler = (data) => {
        dispatch(updateProfile(data, navigate));
    }

    useEffect(() => {
        setValue('firstName', user?.firstName ?? '');
        setValue('lastName', user?.lastName ?? '');
        setValue('gender', user?.additionalDetails?.gender ?? 'Gender');
        setValue('dateOfBirth', user?.additionalDetails?.dateOfBirth ?? '');
        setValue('countryCode', user?.additionalDetails?.countryCode ?? '+91');
        setValue('phoneNo', user?.additionalDetails?.contactNumber ?? '');
        setValue('about', user?.additionalDetails?.about ?? '');
    }, [user, setValue]);

    return (
        <div className='w-full'>
            <div className='w-full'>
                <form onSubmit={handleSubmit(updateDetailHandler)}>
                    <div className='my-10 bg-richblack-800 rounded-xl border border-richblack-700 p-8 flex flex-col gap-y-10'>
                        <header className='font-semibold text-lg'>Update Profile Information</header>
                        <div className='flex md:flex-row flex-col gap-x-10 md:gap-y-0 gap-y-6'>
                            <label className='w-full'>
                                <p className='text-[0.875rem] leading-[1.375rem] text-richblack-5 mb-1'>First Name</p>
                                <input
                                    className='w-full p-[12px] bg-richblack-700 rounded-[0.5rem] text-richblack-5 '
                                    style={{ boxShadow: 'rgba(255, 255, 255, 0.18) 0px -1px 0px inset' }}
                                    type='text'
                                    name='firstName'
                                    placeholder='First Name'
                                    {...register('firstName', { required: true })}
                                />
                                {errors.firstName && (
                                    <span className='text-pink-200 text-sm'>Please enter your name</span>
                                )}
                            </label>
                            <label className='w-full'>
                                <p className='text-[0.875rem] leading-[1.375rem] text-richblack-5 mb-1'>Last Name</p>
                                <input
                                    className='w-full p-[12px] bg-richblack-700 rounded-[0.5rem] text-richblack-5 '
                                    style={{ boxShadow: 'rgba(255, 255, 255, 0.18) 0px -1px 0px inset' }}
                                    type='text'
                                    name='lastName'
                                    placeholder='Last Name'
                                    {...register('lastName', { required: true })}
                                />
                            </label>
                        </div>
                        <div className='flex md:flex-row flex-col gap-x-10 md:gap-y-0 gap-y-6'>
                            <label className='w-full'>
                                <p className='text-[0.875rem] leading-[1.375rem] text-richblack-5 mb-1'>Date of Birth</p>
                                <input
                                    className='w-full p-[12px] bg-richblack-700 rounded-[0.5rem] text-richblack-5 '
                                    style={{ boxShadow: 'rgba(255, 255, 255, 0.18) 0px -1px 0px inset' }}
                                    type='date'
                                    name='dateOfBirth'
                                    id='dateOfBirth'
                                    {...register('dateOfBirth', { required: true })}
                                />
                                {errors.firstName && (
                                    <span className='text-pink-200 text-sm'>Please enter your Date of Birth</span>
                                )}
                            </label>
                            <label className='w-full'>
                                <p className='text-[0.875rem] leading-[1.375rem] text-richblack-5 mb-1'>Gender</p>
                                <div className='flex items-center gap-x-3'>
                                    <select
                                        className='w-full p-[12px] bg-richblack-700 rounded-[0.5rem] text-richblack-5 '
                                        style={{ boxShadow: 'rgba(255, 255, 255, 0.18) 0px -1px 0px inset' }}
                                        name='gender'
                                        id='gender'
                                        placeholder='Male'
                                        {...register('gender', { required: true })}
                                    >
                                        <option defaultChecked value='Gender'>Gender</option>
                                        <option value='Male'>Male</option>
                                        <option value='Female'>Female</option>
                                        <option value='Transgender'>Transgender</option>
                                    </select>
                                </div>
                            </label>
                        </div>
                        <div className='flex md:flex-row flex-col gap-x-10 md:gap-y-0 gap-y-6'>
                            <label htmlFor='phoneNo' className='w-full'>
                                <p className='text-[0.875rem] leading-[1.375rem] text-richblack-5 mb-1'>Phone Number</p>
                                <div className='flex items-center gap-x-3'>
                                    <select
                                        className='p-[12px] bg-richblack-700 rounded-[0.5rem] w-[5rem] text-richblack-5'
                                        style={{ boxShadow: 'rgba(255, 255, 255, 0.18) 0px -1px 0px inset' }}
                                        name='dropdown'
                                        id='dropdown'
                                        {...register("countryCode", { required: true })}
                                    >
                                        {CountryCode.map((code, index) => {
                                            return (
                                                <option key={index} value={code.code}>
                                                    {code.code} - {code.country}
                                                </option>
                                            )
                                        })}
                                    </select>
                                    <div className='relative flex w-full'>
                                        <input
                                            className='p-[12px] w-full bg-richblack-700 rounded-[0.5rem] text-richblack-5'
                                            style={{ boxShadow: 'rgba(255, 255, 255, 0.18) 0px -1px 0px inset' }}
                                            type='number'
                                            placeholder='12345 67890'
                                            name='phoneNo'
                                            id='phoneNo'
                                            {...register("phoneNo",
                                                {
                                                    required: { value: true, message: 'Please enter your Phone Number' },
                                                    maxLength: { value: 10, message: 'Invalid Phone Number' },
                                                    minLength: { value: 8, message: 'Invalid Phone Number' },
                                                }
                                            )}
                                        />
                                        {errors.phoneNo && (<span className='text-pink-200 text-sm absolute -bottom-6'>{errors.phoneNo.message}</span>)}
                                    </div>
                                </div>
                            </label>
                            <label className='w-full'>
                                <p className='text-[0.875rem] leading-[1.375rem] text-richblack-5 mb-1'>About</p>
                                <input
                                    className=' p-[12px] w-full bg-richblack-700 rounded-[0.5rem] text-richblack-5 '
                                    style={{ boxShadow: 'rgba(255, 255, 255, 0.18) 0px -1px 0px inset' }}
                                    type='text'
                                    name='about'
                                    id='about'
                                    placeholder='Write something about you here'
                                    {...register('about', { required: true })}
                                />
                                {errors.firstName && (
                                    <span className='text-pink-200 text-sm'>Please enter something about yourself</span>
                                )}
                            </label>
                        </div>
                    </div>
                    <div className='flex justify-end gap-x-5'>
                        <button
                            type='reset'
                            onClick={() => (navigate('/dashboard/profile'))}
                            className='rounded-md bg-richblack-700 py-2 px-5 font-semibold text-richblack-100'>
                            Cancel
                        </button>
                        <button
                            type='submt'
                            className='flex items-center bg-yellow-50 rounded-md py-2 px-5 font-semibold text-richblack-900'>
                            Save
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default UpdateUserDetails;